<template>
  <v-card flat>
    <v-toolbar
      dense
      class="px-4"
      style="
        z-index: 99999;
        background: linear-gradient(60deg, #66bb6a, #43a047);
        color: white;
        max-height: 64px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        position: fixed;
        top: 0px;
        width: 100%;
      "
    >
      <md-button @click="closeDialog()" class="md-simple md-just-icon">
        <md-icon>close</md-icon>
      </md-button>
      <span
        style="
          font-size: 1.125rem;
          line-height: 1.4em;
          font-weight: 300;
          font-size: 18px;
          margin-left: 16px;
        "
        >{{ this.typeDialog === 'create' ? 'Criar' : 'Editar' }} Nó</span
      >
      <v-spacer></v-spacer>
    </v-toolbar>
    <div
      style="
        height: calc(100vh - 126px);
        padding: 0;
        position: relative;
        top: 47px;
        overflow-y: scroll;
      "
    >
      <v-card-text v-if="nodeData.data" style="padding: 0;">
        <md-card-content style="padding: 0;">
          <div class="md-layout">
            <div
              style="
                padding: 0 32px 16px 32px;
                width: 50%;
                margin-bottom: 16px;
              "
            >
              <div class="titleLabel colorDark" style="margin-top: 12px;">
                {{$t('editNodeDialog.nodeName')}}
              </div>
              <div class="textLabel colorGrey">{{$t('editNodeDialog.optional')}}</div>
              <md-field style="margin-top: 0;">
                <md-input
                  :disabled="isNotCheckedOut"
                  style="
                    background-color: rgb(244, 244, 244);
                    padding-left: 4px;
                  "
                  v-model="nodeData.data.title"
                  placeholder="Adicione um nome para esse nó"
                ></md-input>
              </md-field>
            </div>
            <div
              v-if='nodeData.data.type != "folder"'
              style="
                padding: 28px 32px 28px 32px;
                width: 100%;
                border-top: 1px solid #e0e0e0;
              "
            >
              <div class="md-layout">
                <div
                  class="md-layout-item titleLabel colorDark"
                  style="margin: auto;"
                >
                  {{$t('editNodeDialog.multipleConditionedResponses')}}
                </div>
                <div
                  class="md-layout-item md-form-label md-size-15"
                  style="padding: 0; margin: auto;"
                  :class="{
                    'text-success': customizeResponses,
                    'text-danger': !customizeResponses,
                  }"
                >
                  {{
                    customizeResponses
                      ? $t('commonWords.enabled')
                      : $t('commonWords.disabled')
                  }}
                </div>
                <div class="md-layout-item md-size-15">
                  <md-switch
                    :disabled="isNotCheckedOut"
                    v-model="customizeResponses"
                  ></md-switch>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item">
                  {{$t('editNodeDialog.enableMultipleResponsesSoYourBotCanProvideDifferent')}}
                </div>
              </div>
            </div>
            <div
              v-if="!customizeResponses && nodeData.data.type != 'folder'"
              style="
                padding: 28px 32px 28px 32px;
                width: 100%;
                border-top: 1px solid #e0e0e0;
              "
            >
              <div class="md-layout">
                <div
                  class="md-layout-item titleLabel colorDark"
                  style="margin: auto;"
                >
                  {{$t('editNodeDialog.jsonEditMode')}}
                </div>
                <div
                  class="md-layout-item md-form-label md-size-15"
                  style="padding: 0; margin: auto;"
                  :class="{
                    'text-success': jsonOpen,
                    'text-danger': !jsonOpen,
                  }"
                >
                  {{
                    jsonOpen
                      ? $t('commonWords.enabled')
                      : $t('commonWords.disabled')
                  }}
                </div>
                <div class="md-layout-item md-size-15">
                  <md-switch
                  :disabled="isNotCheckedOut"
                  v-model="jsonOpen"
                  ></md-switch>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item">
                  {{$t('editNodeDialog.activateThisModeToBeAbleToEditTheContextSections')}}
                </div>
              </div>
            </div>
            <Conditions
              :key="condKey"
              v-model="nodeData.data.conditions"
              :context='context'
              :intents="intents"
              :entities="entities"
            />
            <template v-if="!customizeResponses && nodeData.data.type != 'folder'">
              <template v-if="jsonOpen && nodeData && nodeData.data">
                <div style="padding: 0 32px; width: 100%;">
                  <v-row no-gutters style="justify-content: space-between;">
                    <v-col cols="6">
                      <div
                        class="titleLabel colorDark"
                        style="margin-top: 30px; margin-bottom: 12px;"
                      >
                        {{$t('editNodeDialog.jsonEditing')}}
                      </div>
                    </v-col>
                  </v-row>
                  <div style="padding: 0; width: 100%;">
                    <v-row no-gutters style="justify-content: space-between;">
                      <v-col
                        :class="{ 'disable-click': isNotCheckedOut }"
                        cols="12"
                      >
                        <JsonEditor :key="jsonKey" v-model="nodeData.data" />
                      </v-col>
                    </v-row>
                    <v-row no-gutters style="padding-top: 12px;">
                      <v-divider></v-divider>
                    </v-row>
                  </div>
                </div>
              </template>
              <template v-else>
                <div style="padding: 0; width: 100%;">
                  <collapse
                    :collapse="[
                      this.$t('editNodeDialog.thenSetTheContext'),
                      this.$t('editNodeDialog.thenDefineTheActions'),
                      this.$t('editNodeDialog.theAssistantResponds'),
                    ]"
                    :titleStyle="{
                      color: '#393939',
                      fontSize: '20px',
                      lineHeight: '30px',
                      fontWeight: '400',
                      paddingLeft: '32px',
                    }"
                    :containerPadding="'0 32px'"
                    icon="keyboard_arrow_down"
                    color-collapse="success"
                  >
                    <template slot="md-collapse-pane-1">
                      <Context
                        v-model="nodeData.data.context"
                        @toggleJSON="toggleJSON()"
                      />
                    </template>
                    <template slot="md-collapse-pane-2">
                      <template v-if="!noAction">
                        <v-tabs
                          v-model="actionsTab"
                          show-arrows
                          style="
                            color: #6200ea !important;
                            caret-color: #6200ea !important;
                          "
                        >
                          <v-tabs-slider></v-tabs-slider>
                          <v-tab v-for="i in tabs" :key="i" :href="`#tab-${i}`">
                            Action {{ i }}
                            <v-icon
                              v-if="!isNotCheckedOut"
                              @click.stop="removeTab(i)"
                              small
                              color="red"
                              style="margin-left: 4px;"
                            >
                              mdi-close-circle</v-icon
                            >
                          </v-tab>
                          <div
                            v-if="!isNotCheckedOut"
                            class="v-tab v-tab--active"
                            aria-selected="true"
                            @click="newTab()"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </div>
                          <v-tab-item
                            v-for="i in tabs"
                            :key="'tab-' + i"
                            :value="'tab-' + i"
                          >
                            <Actions
                              v-model="nodeData.data.actions[i - 1]"
                              :readOnly="isNotCheckedOut"
                            />
                          </v-tab-item>
                        </v-tabs>
                      </template>
                      <template v-else>
                        <div>
                          {{$t('editNodeDialog.thereIsNoActionAssignedYet')}}
                        </div>
                        <v-row
                          no-gutters
                          style="
                            padding: 12px 0 0 0;
                            justify-content: space-between;
                          "
                        >
                          <v-col cols="auto">
                            <md-button
                              :disabled="isNotCheckedOut"
                              @click="newTab()"
                              style="float: left;"
                              class="md-facebook md-sm"
                            >
                              <img
                                src="../../public/img/plus.png"
                                style="
                                  height: 26px;
                                  width: 26px;
                                  margin-right: 10px;
                                  filter: invert(100%);
                                "
                              />
                              <span>{{$t('editNodeDialog.addAnAction')}}</span>
                            </md-button>
                          </v-col>
                        </v-row>
                        <v-row no-gutters style="padding-top: 12px;">
                          <v-divider></v-divider>
                        </v-row>
                      </template>
                    </template>
                    <template slot="md-collapse-pane-3">
                      <template v-if="nodeData.data.output">
                        <div
                          v-for="(response, i) in nodeData.data.output.generic"
                          :key="'response-' + i"
                          :style="
                            i % 2 == 0 ? {} : { backgroundColor: '#f7f7f7' }
                          "
                          style="
                            width: 100%;
                            padding-top: 12px;
                            padding-bottom: 24px;
                          "
                        >
                          <v-row v-if="i > 0" no-gutters>
                            <v-divider></v-divider>
                          </v-row>
                          <v-row
                            no-gutters
                            style="width: 100%; justify-content: space-between;"
                          >
                            <v-col xs="12" sm="4" cols="4">
                              <md-field style="margin-top: 8px;">
                                <md-select
                                  :disabled="isNotCheckedOut"
                                  style="
                                    background-color: rgb(244, 244, 244);
                                    padding-left: 4px;
                                  "
                                  v-model="response.response_type"
                                >
                                  <md-option value="text">Texto</md-option>
                                </md-select>
                              </md-field>
                            </v-col>
                            <v-col cols="auto" style="align-self: center;">
                              <span
                                :class="{ 'disable-click': isNotCheckedOut }"
                                @click="moveUp(i, 'not-customizable')"
                              >
                                <md-icon
                                  :style="
                                    isFirst(i, 'not-customizable')
                                      ? { color: 'gray', cursor: '' }
                                      : { color: 'blue', cursor: 'pointer' }
                                  "
                                  style="padding: 3px 5px; margin: 3px;"
                                  >expand_less</md-icon
                                >
                                <md-tooltip
                                  v-if="!isFirst(i, 'not-customizable')"
                                  md-direction="left"
                                  >{{$t('editNodeDialog.moveUp')}}</md-tooltip
                                >
                              </span>
                              <span
                                :class="{ 'disable-click': isNotCheckedOut }"
                                @click="moveDown(i, 'not-customizable')"
                              >
                                <md-icon
                                  :style="
                                    isLast(i, 'not-customizable')
                                      ? { color: 'gray', cursor: '' }
                                      : { color: 'blue', cursor: 'pointer' }
                                  "
                                  style="padding: 3px 5px; margin: 3px;"
                                  >expand_more</md-icon
                                >
                                <md-tooltip
                                  v-if="!isLast(i, 'not-customizable')"
                                  md-direction="left"
                                  >{{$t('editNodeDialog.moveDown')}}</md-tooltip
                                >
                              </span>
                              <span
                                :class="{ 'disable-click': isNotCheckedOut }"
                                @click="deleteResponse(i, 'not-customizable')"
                              >
                                <md-icon
                                  style="
                                    cursor: pointer;
                                    color: #f44336;
                                    padding: 3px 5px;
                                    margin: 3px;
                                  "
                                  >delete</md-icon
                                >
                                <md-tooltip md-direction="left"
                                  >{{$t('editNodeDialog.removeAnswerType')}}</md-tooltip
                                >
                              </span>
                            </v-col>
                          </v-row>
                          <div
                            v-for="(value, j) in addValueText(
                              response.values,
                              i
                            )"
                            :key="'respose-variation-' + j"
                            style="padding: 16px 0 0 0; width: 100%;"
                          >
                            <v-row no-gutters>
                              <v-col cols="11">
                                <div class="contQuill">
                                  <quill-editor
                                    :class="{
                                      'disable-click': isNotCheckedOut,
                                    }"
                                    class="editor"
                                    ref="myTextEditor"
                                    :value="createHtml(value.text)"
                                    :options="editorOption"
                                    @change="
                                      onEditorChange(
                                        $event,
                                        i,
                                        j,
                                        'not-customizable'
                                      )
                                    "
                                  />
                                </div>
                              </v-col>
                              <v-col cols="1" style="align-self: center;">
                                <span
                                  v-if="j == 0 && value.text == ''"
                                  :class="{ 'disable-click': isNotCheckedOut }"
                                >
                                  <md-icon
                                    style="color: gray; padding-left: 24px;"
                                    >remove_circle</md-icon
                                  >
                                </span>
                                <span
                                  v-else
                                  :class="{ 'disable-click': isNotCheckedOut }"
                                  @click="
                                    deleteVariations(i, j, 'not-customizable')
                                  "
                                >
                                  <md-icon
                                    style="
                                      cursor: pointer;
                                      color: #f44336;
                                      padding-left: 24px;
                                    "
                                    >remove_circle</md-icon
                                  >
                                  <md-tooltip md-direction="bottom"
                                    >{{$t('editNodeDialog.removeAnswerVariation')}}</md-tooltip
                                  >
                                </span>
                              </v-col>
                            </v-row>
                          </div>
                          <div
                            style="
                              padding-top: 16px;
                              padding: 16px 0 0 0;
                              width: 100%;
                            "
                          >
                            <span
                              :class="{ 'disable-click': isNotCheckedOut }"
                              @click="addVariations(i, 'not-customizable')"
                              style="color: #4caf50; cursor: pointer;"
                            >
                              <md-icon style="color: #4caf50;"
                                >add_circle</md-icon
                              >
                              <div style="line-height: 24px; display: inline;">
                                &nbsp;{{$t('editNodeDialog.add')}}
                              </div>
                              <md-tooltip md-direction="bottom"
                                >{{$t('editNodeDialog.addAnswerVariation')}}</md-tooltip
                              >
                            </span>
                          </div>
                          <div
                            style="
                              padding-top: 16px;
                              padding: 16px 0 0 0;
                              width: 100%;
                            "
                          >
                            {{$t('editNodeDialog.responseVariationsAreDefinedFor')}}
                            <b>
                              {{
                                variationType(response.selection_policy)
                                  .selected
                              }}.
                            </b>
                            Defina para
                            <span
                              :class="{ 'disable-click': isNotCheckedOut }"
                              @click="
                                changeVariationType(
                                  i,
                                  variationType(response.selection_policy)
                                    .variations[0],
                                  'not-customizable'
                                )
                              "
                              class="variationSelected"
                            >
                              {{
                                variationType(response.selection_policy)
                                  .variations[0]
                              }}
                            </span>
                            ou
                            <span
                              :class="{ 'disable-click': isNotCheckedOut }"
                              @click="
                                changeVariationType(
                                  i,
                                  variationType(response.selection_policy)
                                    .variations[1],
                                  'not-customizable'
                                )
                              "
                              class="variationSelected"
                            >
                              {{
                                variationType(response.selection_policy)
                                  .variations[1]
                              }}
                            </span>
                          </div>
                        </div>
                      </template>
                      <div style="padding: 0 0 24px 0; width: 100%;">
                        <v-row no-gutters style="padding: 0;">
                          <v-divider></v-divider>
                        </v-row>
                        <v-row
                          no-gutters
                          style="
                            padding: 12px 0 0 0;
                            justify-content: space-between;
                          "
                        >
                          <v-col cols="auto">
                            <md-button
                              :disabled="isNotCheckedOut"
                              @click="addResponse('not-customizable')"
                              style="float: left;"
                              class="md-facebook md-sm"
                            >
                              <img
                                src="../../public/img/plus.png"
                                style="
                                  height: 26px;
                                  width: 26px;
                                  margin-right: 10px;
                                  filter: invert(100%);
                                "
                              />
                              <span>{{$t('editNodeDialog.addAnswerType')}}</span>
                            </md-button>
                          </v-col>
                        </v-row>
                        <v-row no-gutters style="padding-top: 12px;">
                          <v-divider></v-divider>
                        </v-row>
                      </div>
                    </template>
                  </collapse>
                </div>
              </template>
            </template>
            <!-- se estiver no modo de respostas customizadas -->
            <template v-else-if="nodeData.data.type != 'folder'">
              <div style="padding: 0 32px; width: 100%;">
                <v-row no-gutters style="justify-content: space-between;">
                  <v-col cols="12">
                    <div
                      class="titleLabel colorDark"
                      style="margin-top: 30px; margin-bottom: 12px;"
                    >
                      {{$t('editNodeDialog.theAssistantResponds')}}
                    </div>
                  </v-col>
                </v-row>
                <v-row v-show="nodeData.data.outputResponses.length" no-gutters>
                  <v-col cols="1"></v-col>
                  <v-col cols="4">
                    <b>{{$t('editNodeDialog.ifTheWizardRecognizes')}}</b>
                  </v-col>
                  <v-col cols="5">
                    <b>{{$t('editNodeDialog.answerWith')}}</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </div>
              <div
                v-for="(response, i) in nodeData.data.outputResponses"
                :key="'customized-resp-condition-' + i"
                style="width: 100%; padding-bottom: 12px;"
              >
                <v-row
                  no-gutters
                  style="padding: 0 32px; width: 100%; margin-bottom: 12px;"
                >
                  <v-col
                    cols="1"
                    style="
                      align-self: center;
                      text-align: center;
                      font-weight: 700;
                      font-size: 16px;
                    "
                    >{{ i + 1 }}</v-col
                  >
                  <v-col cols="4" style="padding-right: 28px;">
                    <md-field style="margin-top: 8px;">
                      <md-input
                        :disabled="isNotCheckedOut"
                        v-model="response.conditions"
                        style="
                          background-color: rgb(244, 244, 244);
                          padding-left: 4px;
                        "
                        :placeholder="$t('editNodeDialog.betweenACondition')"
                      ></md-input>
                    </md-field>
                  </v-col>
                  <v-col
                    cols="5"
                    style="padding-right: 28px; align-self: center;"
                  >
                    <template v-if="hasOneGeneric(response.output)">
                      <md-field style="margin-top: 8px;">
                        <md-input
                          :disabled="isNotCheckedOut"
                          v-model="response.output.generic[0].values[0].text"
                          style="
                            background-color: rgb(244, 244, 244);
                            padding-left: 4px;
                          "
                          :placeholder="$t('editNodeDialog.betweenAnAnswer')"
                        ></md-input>
                      </md-field>
                    </template>
                    <template v-else-if="response.output">
                      <span>
                        {{
                          response.output.generic
                            .map((item) =>
                              item.response_type == 'text'
                                ? 'Texto'
                                : item.response_type
                            )
                            .join(', ')
                        }}
                      </span>
                    </template>
                  </v-col>
                  <v-col
                    cols="1"
                    style="align-self: center; text-align: center;"
                  >
                    <span>
                      <svg
                        @click="openCustomizeDialog(response, i)"
                        style="
                          width: 24px;
                          height: 24px;
                          cursor: pointer;
                          color: blue;
                        "
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18,2.9 17.4,2.9 17,3.3L15.2,5.1L19,8.9M3,17.2V21H6.8L17.8,9.9L14.1,6.1L3,17.2M7,2V5H10V7H7V10H5V7H2V5H5V2H7Z"
                        />
                      </svg>
                      <md-tooltip md-direction="bottom">
                        {{$t('editNodeDialog.editAnswerType')}}
                      </md-tooltip>
                    </span>
                  </v-col>
                  <v-col
                    cols="1"
                    style="align-self: center; text-align: center;"
                  >
                    <span
                      @click="removeCustomizedResponse(response, i)"
                      :class="{ 'disable-click': isNotCheckedOut }"
                    >
                      <md-icon
                        style="
                          cursor: pointer;
                          color: blue;
                          margin-bottom: 10px;
                        "
                        >horizontal_rule</md-icon
                      >
                      <md-tooltip md-direction="bottom">
                        {{$t('editNodeDialog.removeAnswerType')}}
                      </md-tooltip>
                    </span>
                  </v-col>
                </v-row>
                <v-row no-gutters style="padding: 0 32px;">
                  <v-divider></v-divider>
                </v-row>
              </div>
              <div style="padding: 0 32px 24px 32px; width: 100%;">
                <v-row
                  no-gutters
                  style="padding: 8px 0 0 0; justify-content: space-between;"
                >
                  <v-col cols="auto">
                    <md-button
                      :disabled="isNotCheckedOut"
                      @click="addResponse('not-customizable')"
                      style="float: left;"
                      class="md-facebook md-sm"
                    >
                      <img
                        src="../../public/img/plus.png"
                        style="
                          height: 26px;
                          width: 26px;
                          margin-right: 10px;
                          filter: invert(100%);
                        "
                      />
                      <span>{{$t('editNodeDialog.addAnswerType')}}</span>
                    </md-button>
                  </v-col>
                </v-row>
              </div>
            </template>
            <div
              v-if="nodeData.data.next_step && nodeData.data.type != 'folder'"
              style="padding: 0 32px 12px 32px; width: 100%;"
            >
              <v-row
                no-gutters
                style="justify-content: space-between; margin-top: 30px;"
              >
                <v-col cols="12">
                  <div
                    class="titleLabel colorDark"
                    style="margin-bottom: 12px;"
                  >
                    {{$t('editNodeDialog.thenTheAssistantMust')}}
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters style="justify-content: space-between;">
                <v-col cols="4">
                  <md-field style="margin-top: 8px;">
                    <md-select
                      :disabled="isNotCheckedOut"
                      placeholder="Selecione"
                      style="
                        background-color: rgb(244, 244, 244);
                        padding-left: 4px;
                      "
                      @md-selected="changedSelectedBehavior()"
                      v-model="selectedBehavior"
                    >
                      <md-option value="jump_to">{{$t('editNodeDialog.goTo')}}</md-option>
                      <md-option
                        v-if="nodeData.children.length > 0"
                        value="skip_user_input"
                        >{{$t('editNodeDialog.skipUserInput')}}</md-option
                      >
                      <md-option value="get_user_input"
                        >{{$t('editNodeDialog.waitForReply')}}</md-option
                      >
                    </md-select>
                  </md-field>
                </v-col>
                <v-col
                  v-if="
                    nodeData.data.next_step.behavior === 'jump_to' &&
                    !isNotCheckedOut
                  "
                  cols="auto"
                >
                  <v-row no-gutters style="padding: 0;">
                    <v-col
                      @click="selectedBehavior = 'get_user_input'"
                      style="cursor: pointer; align-self: center;"
                      cols="auto"
                    >
                      <span
                        style="
                          text-decoration: underline;
                          font-size: 16px;
                          color: #0f62fe;
                        "
                        >({{ selectorType }})</span
                      >
                    </v-col>
                    <v-col id="removeJumpNode" cols="auto">
                      <md-button
                        @click="selectedBehavior = 'get_user_input'"
                        class="md-simple md-just-icon"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters style="justify-content: space-between;">
                <v-col
                  id="cardJump"
                  v-if="nodeData.data.next_step.behavior === 'jump_to'"
                  cols="12"
                >
                  <md-card
                    id="node-preview"
                    class="node-content drag-trigger before-parent node-card-class"
                    style="cursor: pointer; position: relative; width: 700px;"
                  >
                    <v-row no-gutters>
                      <v-col
                        @click="
                          scrollToNode(nodeData.data.next_step.dialog_node)
                        "
                        cols="auto"
                        style="align-items: center;"
                      >
                        <button id="expand-button-id" class="button-expand">
                          <md-icon
                            v-if="
                              nodeMap[this.nodeData.data.next_step.dialog_node]
                                .children.length > 0
                            "
                            class="icon-expand not-expanded"
                            >chevron_right</md-icon
                          >
                          <md-icon v-else class="icon-expand">remove</md-icon>
                        </button>
                      </v-col>
                      <v-col
                        @click="
                          scrollToNode(nodeData.data.next_step.dialog_node)
                        "
                        cols="auto"
                      >
                        <v-card style="width: 626px;" flat>
                          <v-list-item
                            v-if="
                              nodeMap[this.nodeData.data.next_step.dialog_node]
                                .data.title
                            "
                            two-line
                          >
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1">
                                {{
                                  nodeMap[
                                    this.nodeData.data.next_step.dialog_node
                                  ].data.title
                                }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{$t('editNodeDialog.ifYouRecognize')}}
                                <b>
                                  {{
                                    loopAssisRec(
                                      nodeMap[
                                        this.nodeData.data.next_step.dialog_node
                                      ]
                                    )
                                  }}
                                </b>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item v-else>
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1">
                                {{
                                  loopAssisRec(
                                    nodeMap[
                                      this.nodeData.data.next_step.dialog_node
                                    ]
                                  )
                                }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-card-actions>
                            <v-chip-group column active-class="primary--text">
                              <v-chip small>
                                {{
                                  respostas(
                                    nodeMap[
                                      this.nodeData.data.next_step.dialog_node
                                    ]
                                  )
                                }}{{ ' ' }}
                                {{$t('editNodeDialog.answers')}}
                              </v-chip>
                              <v-chip small>
                                {{
                                  returnContext(
                                    nodeMap[
                                      this.nodeData.data.next_step.dialog_node
                                    ]
                                  )
                                }}
                                {{ ' ' }}
                                {{$t('editNodeDialog.contextDefined')}}
                              </v-chip>
                              <v-chip
                                color="#3b5998"
                                dark
                                text-color="#ffffff"
                                v-if="
                                  nodeMap[
                                    this.nodeData.data.next_step.dialog_node
                                  ].data.jumpTo
                                "
                                small
                              >
                                <v-icon small left>mdi-logout-variant</v-icon
                                >{{$t('editNodeDialog.jumpTo')}}
                              </v-chip>
                            </v-chip-group>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </md-card>
                </v-col>
              </v-row>
            </div>
            <ChildNodes
              v-if="nodeData.data.type == 'folder' && nodeData.children.length > 0"
              @scrollNode='scrollToNode($event)'
              :nodeData='nodeData'
              style='width: 100%;' />
          </div>
        </md-card-content>
      </v-card-text>
    </div>
    <div class="saveDiv">
      <div style="width: 100%; padding: 0 32px 16px 32px;">
        <div
          class="md-layout"
          style="width: 100%; justify-content: flex-end; margin-top: 12px;"
        >
          <md-button
            :disabled="isNotCheckedOut || isValid"
            @click="saveNewNode"
            class="md-success"
          >
            <span>{{$t('editNodeDialog.save')}}</span>
          </md-button>
        </div>
      </div>
    </div>
    <!-- <md-dialog :md-active.sync="customizeResponseDialog">
      <CustomizeResponse @close-customize-response-dialog="customizeResponseDialog = false" :outputResponseItem='responseProp' :outputResponseIndex='responseIndex'/>
    </md-dialog>-->
    <!-- v-if='!selectNodeMode.active' -->
    <v-dialog
      v-model="customizeResponseDialog"
      persistent
      max-width="1000px"
      :scrollable="true"
    >
      <CustomizeResponse
        ref="customizeResponseDialog"
        :key="customizeDialogKey"
        @scrollNodeCustomize="emitNode"
        :context="context"
        :intents="intents"
        :entities="entities"
        :nodeData="nodeData"
        :nodeMap="nodeMap"
        @close-customize-response-dialog="closeCustomizeDialog"
        :outputResponseItem="responseProp"
        :outputResponseIndex="responseIndex"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import CustomizeResponse from './CustomizeResponse'
import JsonEditor from './JsonEditor'
import Collapse from './Reuse/Collapse'
import Context from './EditDialog/Context'
import Actions from './EditDialog/Actions'
import Conditions from './EditDialog/Conditions'
import ChildNodes from './EditDialog/ChildNodes'
import { mapFields } from 'vuex-map-fields'
import responseMixin from './mixins/responseMixin'
import { setPreviousSibling } from '@/helpers/dialogTree'
import clonedeep from 'lodash.clonedeep'
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    treeData: {
      required: true,
      type: Array
    },
    node: {
      required: true,
      type: Object
    },
    entities: {
      required: true,
      type: Array
    },
    intents: {
      required: true,
      type: Array
    },
    nodeMap: {
      required: true,
      type: Object
    }
  },
  components: {
    CustomizeResponse,
    JsonEditor,
    Collapse,
    Context,
    Actions,
    Conditions,
    ChildNodes
  },
  mixins: [responseMixin],
  data () {
    return {
      context: [],
      axios: null,
      nodeData: {},
      attAdd: '',
      customizeResponses: null,
      responseProp: {},
      responseIndex: 0,
      jsonOpen: false,
      selectedBehavior: 'get_user_input',
      dialogChangeFlag: false,
      customizeDialogKey: 0,
      jsonKey: 0,
      condKey: 0,
      noAction: true,
      actionsTab: 'tab-1',
      tabs: 0,
      outputResponseItemCopy: {}
    }
  },
  watch: {
    node (newData) {
      if (newData.data) {
        this.customizeResponses = null

        this.nodeData = clonedeep(this.node)
        const { next_step: nextStep, type } = this.nodeData.data
        if (type !== 'folder' && !nextStep) {
          this.nodeData.data.next_step = {
            behavior: 'get_user_input'
          }
        }

        this.selectedBehavior = nextStep?.behavior

        if (this.nodeData.data && this.nodeData.data.metadata && this.nodeData.data.metadata._customization && this.nodeData.data.metadata._customization.mcr) {
          this.customizeResponses = this.nodeData.data.metadata._customization.mcr
        } else {
          this.customizeResponses = false
        }

        this.addContextToConditionItems()

        this.jsonKey++
        this.condKey++

        this.noAction =
          typeof newData.data.actions === typeof undefined ||
          newData.data.actions === []
        this.tabs = newData.data.actions?.length || 0

        this.dialogChangeFlag = true
        this.$nextTick(() => {
          this.dialogChangeFlag = false
        })
      }
    },
    customizeResponses (newValue, oldValue) {
      if (oldValue !== null) {
        // This change actually came from the user clicking the switch and not
        // from changing the selected node.
        this.updateNodeResponses()
      }
    },
    selector (newValue) {
      if (newValue !== '') {
        if (this.selectNodeModeValue === 0) {
          this.nodeData.data.next_step.dialog_node = this.dialog_node
          this.nodeData.data.next_step.selector = this.selector
          this.nodeData.data.next_step.behavior = this.behavior
          this.selector = ''
          this.behavior = ''
          this.dialog_node = ''
          this.$forceUpdate()
        }
      }
    }
  },
  computed: {
    ...mapFields('dialogEdit', [
      'editDialog',
      'customizeResponseDialog',
      'nodePath',
      'typeDialog'
    ]),
    ...mapFields('dialogEdit', {
      behavior: 'nodeJumpSelect.behavior',
      dialog_node: 'nodeJumpSelect.dialog_node',
      selector: 'nodeJumpSelect.selector',
      selectNodeModeValue: 'selectNodeMode.value',
      selectNodeModeActive: 'selectNodeMode.active',
      selectNodeModeOutputResponseIndex: 'selectNodeMode.outputResponseIndex',
      selectNodeModeDialogTitle: 'selectNodeMode.dialogTitle'
    }),
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    },
    isValid () {
      // todo needs implement emit
      // const hasEmptyName = Object.keys(this.nodeData.data.context).some(name => name === '')
      // return hasEmptyName
      return false
    },
    selectorType () {
      if (this.nodeData.data.next_step.selector === 'user_input') {
        return this.$t('editNodeDialog.waitsForUserInputThenEvaluatesTheCondition')
      } else if (this.nodeData.data.next_step.selector === 'condition') {
        return this.$t('editNodeDialog.assessCondition')
      } else if (this.nodeData.data.next_step.selector === 'body') {
        return this.$t('editNodeDialog.evaluateResponses')
      }
      return ''
    }
  },
  methods: {
    hasOneGeneric (output) {
      if (output?.generic?.length === 1) {
        const generic = output.generic[0]
        if (!generic.values) {
          generic.values = [{ text: '' }]
        } else if (!generic.values[0]) {
          generic.values.push({ text: '' })
        }
        return true
      }
      return false
    },
    updateNodeResponses () {
      const nodeData = this.nodeData.data
      if (this.customizeResponses !== null) {
        if (!nodeData.metadata) {
          nodeData.metadata = {}
        }
        if (!nodeData.metadata._customization) {
          nodeData.metadata._customization = {}
        }
        nodeData.metadata._customization.mcr = this.customizeResponses
        nodeData.outputResponses.forEach((response) => {
          response.disabled = !this.customizeResponses
        })
      }

      if (this.customizeResponses === true) {
        nodeData.outputResponses =
          nodeData.outputResponses ||
          this.newOutputResponses(nodeData?.output?.generic, nodeData?.context)
      }

      if (this.customizeResponses === false) {
        const oldOutputResponse = nodeData.outputResponses[0]
        nodeData.output = {}
        nodeData.output.generic = oldOutputResponse?.output?.generic || [
          {
            values: [
              {
                text: ''
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
        nodeData.context = oldOutputResponse?.context || {}
      }
    },
    addContextToConditionItems () {
      const context = []
      if (!this.nodeData.data?.metadata?._customization?.mcr) {
        const keys = Object.keys(
          this?.nodeData?.data?.context || {}
        ).map((key) => ({ text: `${key}` }))
        context.push(...keys)
      } else {
        const keys = []
        this.nodeData.data.outputResponses.forEach((response) => {
          keys.push(...Object.keys(response.context || {}))
        })

        const keysSet = [...new Set(keys)].map((key) => ({
          text: `${key}`
        }))
        context.push(...keysSet)
      }
      this.context = context
    },
    newOutputResponses (generic, context) {
      return [
        {
          type: 'response_condition',
          dialog_node: `customResponse_${uuidv4()}`,
          output: {
            generic: generic || [
              {
                values: [
                  {
                    text: ''
                  }
                ],
                response_type: 'text',
                selection_policy: 'sequential'
              }
            ]
          },
          next_step: {
            behavior: 'skip_user_input'
          },
          context: context,
          conditions: ''
        }
      ]
    },
    closeDialog () {
      this.typeDialog = ''
      this.$emit('closeDialog', false)
    },
    async saveNewNode () {
      const firstSon = this.nodeData.children[0]
      if (firstSon) {
        setPreviousSibling(firstSon, null, this.nodeData)
      }
      this.$emit('save', {
        node: this.nodeData
      })
    },
    openCustomizeDialog (response, index) {
      this.outputResponseItemCopy = clonedeep(response)
      this.responseProp = response
      this.responseIndex = index
      this.customizeResponseDialog = true
      this.customizeDialogKey++
    },
    closeCustomizeDialog (response) {
      if (response) {
        this.nodeData.data.outputResponses[this.responseIndex] = response
      } else {
        this.nodeData.data.outputResponses[this.responseIndex] = this.outputResponseItemCopy
      }
      this.customizeResponseDialog = false
      // this.$refs.customizeResponseDialog.$destroy()
    },
    removeCustomizedResponse (response, i) {
      this.nodeData.data.outputResponses.splice(i, 1)
    },
    toggleJSON () {
      this.jsonOpen = !this.jsonOpen
    },
    changedSelectedBehavior () {
      this.$forceUpdate()
      if (!this.dialogChangeFlag) {
        if (this.selectedBehavior !== 'jump_to') {
          this.nodeData.data.next_step.behavior = this.selectedBehavior
          delete this.nodeData.data.next_step.dialog_node
          delete this.nodeData.data.next_step.selector
        } else {
          this.toSelectNode()
        }
      }
    },
    toSelectNode () {
      this.selectNodeModeActive = true
      this.selectNodeModeValue = 0
      this.selectNodeModeDialogTitle =
      this.nodeData.data.title || this.nodeData.data.conditions
      this.editDialog = false
      this.topMenu = true
    },
    loopAssisRec (node) {
      return node.data.conditions
    },
    respostas (node) {
      return (
        node?.data?.output?.generic?.length ||
        node?.data?.outputResponses?.length ||
        0
      )
    },
    returnContext (node) {
      if (!node.data?.metadata?._customization?.mcr) {
        // se não tiver customização de respostas
        if (node.data.context) {
          return Object.keys(node.data.context).length + ' '
        } else return '0 '
      } else {
        let customContexts = {}
        for (let i = 0; i < node.data.outputResponses.length; i++) {
          customContexts = {
            ...customContexts,
            ...node.data.outputResponses[i]
          }
        }
        return Object.keys(customContexts).length + ' '
      }
    },
    scrollToNode (id) {
      const node = this.nodeMap[id]
      let parent = node.data.parent
      while (parent) {
        const nodeParent = this.nodeMap[parent]
        nodeParent.$folded = false
        parent = nodeParent.data.parent
      }
      this.$emit('scrollNode', node)
    },
    emitNode (node) {
      this.$emit('scrollNode', node)
    },
    addValueText (valuesArr, index) {
      // just to add { text: "" } inside array values if it doesn't exist
      if (!valuesArr.length) {
        this.nodeData.data.output.generic[index].values = [{ text: '' }]
      }
      return valuesArr
    },
    newTab () {
      let newAction = {
        name: 'ApiRequest',
        parameters: {},
        type: 'client',
        result_variable: 'success'
      }
      if (
        !this.nodeData.data.actions ||
        this.nodeData.data.actions.length === 0
      ) {
        this.nodeData.data.actions = [newAction]
        this.tabs = 1
        this.$nextTick(() => {
          this.actionsTab = `tab-1`
          this.noAction = false
        })
      } else {
        this.nodeData.data.actions.push(newAction)
        // this.actionsTab = 'tab-' + this.nodeData.data.actions.length
        this.tabs += 1
        this.$nextTick(function () {
          this.actionsTab = `tab-${this.tabs}`
        })
      }
    },
    removeTab (i) {
      if (`tab-${i}` === this.actionsTab) {
        let prevTab = i - 1
        this.actionsTab = 'tab-' + prevTab
      }
      setTimeout(() => {
        this.nodeData.data.actions.splice(i - 1, 1)
        this.tabs = this.tabs - 1
        if (this.nodeData.data.actions.length === 0) {
          this.noAction = true
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
.contQuill {
  display: flex;
  flex-direction: column;
}
.md-button.md-simple i {
  color: white !important;
}
#removeJumpNode > .md-button.md-simple i {
  color: rgb(244, 67, 54) !important;
}
.textLabel {
  width: 100%;
  font-size: 14px;
  line-height: 24px;
}
.titleLabel {
  width: 100%;
  font-size: 20px;
  line-height: 30px;
}
.colorDark {
  color: #393939;
}
.colorGrey {
  color: rgba(111, 111, 111, 0.603);
}
.md-menu-content {
  z-index: 203 !important;
}
.md-tooltip {
  height: 22px !important;
  padding: 8px !important;
  position: absolute !important;
  z-index: 9999 !important;
  pointer-events: none !important;
  border-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
  transition-property: opacity, transform !important;
  will-change: opacity, transform, top, left !important;
  font-size: 10px !important;
  line-height: 22px !important;
  text-transform: none !important;
  white-space: nowrap !important;
  min-width: none !important;
  width: 170px !important;
  max-width: 1000px !important;
  height: auto !important;
  line-height: 20px !important;
  text-align: center !important;
  border-radius: 3px !important;
  background-color: rgba(97, 97, 97, 0.9) !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  white-space: normal !important;
  box-shadow: none !important;
}
.md-tooltip:after {
  opacity: 0;
}
.variationSelected {
  color: #0f62fe;
  font-weight: 400;
  letter-spacing: 0.16px;
  cursor: pointer;
}
.variationSelected:hover {
  text-decoration: underline;
}
.md-button.md-facebook {
  background-color: #0f62fe !important;
}
.md-button.md-facebook:hover,
.md-button.md-facebook:focus,
.md-button.md-facebook:active,
.md-button.md-facebook.active,
.md-button.md-facebook:active:focus,
.md-button.md-facebook:active:hover,
.md-button.md-facebook.active:focus,
.md-button.md-facebook.active:hover {
  background-color: #0f62fe !important;
  color: #fff !important;
  -webkit-box-shadow: 0 14px 26pxnode -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
  box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
}
.disable-click {
  pointer-events: none;
}
#cardJump > .md-card {
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.14) !important;
}
/* div>.col>.jsoneditor-container>.jsoneditor-box>.jsoneditor>.jsoneditor-menu {
  background-color: rgb(67, 160, 71) !important;
  border-bottom: 1px solid rgb(67, 160, 71) !important;
}
.jsoneditor-poweredBy {
  display: none !important;
} */
.saveDiv {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 99999;
}
</style>
